import axios from "axios";
import URLS from "../../util/urls.js";

const state = {
  imobiliarias: [],
  qtdImobiliarias: 0,

  imobiliariaSelecionada: {
    id: 0,
    razaoSocial: '',
    cnpj: '',
    status: false,
    dataCadastro: '',
    dataImplantacao: '',
    dataAceite: '',
    endereco: '',
    numeroEndereco: '',
    complemento: '',
    cep: '',
    estado: { id: 0, nome: '' },
    cidade: { id: 0, nome: '' },
    bairro: { id: 0, nome: '' },
    nomeRepresentante: '',
    cargoRepresentante: '',
    cpfRepresentante: '',
    propostaComercial: {
      aluguel: false,
      venda: false,
      appVistoria: false,
      templateSite: false,
      contasEmail: false,
      planoContratado: 'PLANO_100',
      contato: undefined,
      data: '',
      vendedor: '',
      plano100: 0,
      plano250: 0,
      plano500: 0,
      plano1000: 0,
      plano2000: 0,
      plano3000: 0,
      plano3000mais: 0,
      visitaTecnica:  0,
      site: 0,
      siteEmail: 0
    },
  },

  formValidacaoContrato: {
    endereco: '',
    numeroEndereco: '',
    cep: '',
    nomeRepresentante: '',
    cargoRepresentante: '',
    cpfRepresentante: '',
  },

  cidades: [],
  bairros: [],
}

const mutations = {
  setImobiliarias(state, imobiliarias) {
    state.imobiliarias = imobiliarias;
  },

  setQtdImobiliarias(state, qtdImobiliarias) {
    state.qtdImobiliarias = qtdImobiliarias;
  },

  setImobiliariaSelecionada(state, imobiliaria) {
    state.imobiliariaSelecionada = imobiliaria;

    if(imobiliaria.propostaComercial === null) {
      state.imobiliariaSelecionada.propostaComercial = {
        aluguel: false,
        venda: false,
        appVistoria: false,
        templateSite: false,
        contasEmail: false,
        planoContratado: 'PLANO_100',
        contato: undefined,
        data: '',
        vendedor: '',
        plano100: 0,
        plano250: 0,
        plano500: 0,
        plano1000: 0,
        plano2000: 0,
        plano3000: 0,
        plano3000mais: 0,
        visitaTecnica:  0,
        site: 0,
        siteEmail: 0
      };
    }
    
    state.cidades = [imobiliaria.cidade];
    state.bairros = [imobiliaria.bairro];
  },

  setCidades(state, cidades) {
    state.cidades = cidades;
  },
  setBairros(state, bairros) {
    state.bairros = bairros;
  },

  limparFormImobiliaria(state) {
    state.cidades = [];
    state.bairros = [];
    
    state.imobiliariaSelecionada = {
      id: 0,
      razaoSocial: '',
      cnpj: '',
      status: false,
      dataCadastro: '',
      dataImplantacao: '',
      dataAceite: '',
      endereco: '',
      numeroEndereco: '',
      complemento: '',
      cep: '',
      estado: { id: 0, nome: '' },
      cidade: { id: 0, nome: '' },
      bairro: { id: 0, nome: '' },
      nomeRepresentante: '',
      cargoRepresentante: '',
      cpfRepresentante: '',
      propostaComercial: {
        aluguel: false,
        venda: false,
        appVistoria: false,
        templateSite: false,
        contasEmail: false,
        planoContratado: 'PLANO_100',
        contato: undefined,
        data: '',
        vendedor: '',
        plano100: 0,
        plano250: 0,
        plano500: 0,
        plano1000: 0,
        plano2000: 0,
        plano3000: 0,
        plano3000mais: 0,
        visitaTecnica:  0,
        site: 0,
        siteEmail: 0
      },
    };
  },

  limparCidade(state) {
    state.imobiliariaSelecionada.cidade = { id: 0, nome: '' };
    state.cidades = [];
  },

  limparBairro(state) {
    state.imobiliariaSelecionada.bairro = { id: 0, nome: '' };
    state.bairros = [];
  },
  preencherFormValidarContrato(state, payload) {
    state.formValidacaoContrato.endereco = payload.endereco
    state.formValidacaoContrato.numeroEndereco = payload.numeroEndereco
    state.formValidacaoContrato.cep = payload.cep
    state.formValidacaoContrato.nomeRepresentante = payload.nomeRepresentante,
    state.formValidacaoContrato.cargoRepresentante = payload.cargoRepresentante,
    state.formValidacaoContrato.cpfRepresentante = payload.cpfRepresentante
  }
}

const actions = {
  listarImobiliarias(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_PRE_CADASTRADAS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('setImobiliarias', response.data.lista);
          context.commit('setQtdImobiliarias', response.data.quantidade);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("listarImobiliarias", payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    })
  },

  recuperarImobiliaria(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_PRE_CADASTRADAS_RECUPERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('setImobiliariaSelecionada', response.data.item);
          context.commit('preencherFormValidarContrato', response.data.item)
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("recuperarImobiliaria", payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    })
  },

  gravarImobiliaria(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_PRE_CADASTRADAS_GRAVAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('setImobiliariaSelecionada', response.data.item);
          context.commit('preencherFormValidarContrato', response.data.item)
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("gravarImobiliaria", payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    })
  },
  
  removerImobiliaria(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_PRE_CADASTRADAS_REMOVER, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('limparFormImobiliaria');
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("removerImobiliaria", payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    })
  },

  listarCidades(context, payload) {
    return axios.post(URLS.CIDADES_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('setCidades', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("listarCidades", payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    })
  },

  listarBairros(context, payload) {
    return axios.post(URLS.BAIRROS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('setBairros', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("listarBairros", payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    })
  },

  gerarContrato(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_PRE_CADASTRADAS_GERAR_CONTRATO, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('gerarContrato', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    });
  },

  gerarProposta(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_PRE_CADASTRADAS_GERAR_PROPOSTA, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("gerarProposta", payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
}

export default {
  state,
  mutations,
  actions
}